module.exports = __webpack_public_path__ + "static/php-f3ed05c8cd0c52e85e2b45096e802551.jpg";